import { Avatar } from 'avatar-components';
import { ACTOR } from '../../constants/actors';
import { unreachableFallback } from 'ui-product-approvals-common/utils/unreachableFallback';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalUserAvatar = ({
  approvalUser
}) => {
  var _approvalUser$actor;
  const actorType = (_approvalUser$actor = approvalUser.actor) === null || _approvalUser$actor === void 0 ? void 0 : _approvalUser$actor.actorType;
  if (typeof actorType === 'symbol' || actorType === undefined) {
    return /*#__PURE__*/_jsx(Avatar, {
      size: "sm"
    });
  }
  switch (actorType) {
    case ACTOR.USER:
      return /*#__PURE__*/_jsx(Avatar, {
        "data-test-id": "approval-user-avatar",
        size: "sm",
        hubSpotUserEmail: approvalUser.email,
        displayName: approvalUser.email
      });
    case ACTOR.AGENT:
      return /*#__PURE__*/_jsx(Avatar, {
        "data-test-id": "approval-agent-avatar",
        type: "ai-agent",
        size: "sm"
      });
    default:
      return unreachableFallback(actorType, /*#__PURE__*/_jsx(Avatar, {
        size: "sm"
      }));
  }
};